/*
Asset: wishlist-variant-sync.js
Automatically included by wishlist-button block.
Listens for Shopify variant change events and updates the
wishlist-button element's data attributes so the correct variant
gets saved to the wishlist.
Supports:
- Native Shopify variant selector (select[name="id"])
- Theme-dispatched "variant:change" custom event
- Broadcast channel from sections/main-product
*/
(function () {
'use strict';
function syncVariant(variantId, variantTitle, price, comparePrice) {
document.querySelectorAll('wishlist-button').forEach((el) => {
if (variantId) el.dataset.variantId=variantId;
if (variantTitle) el.dataset.variantTitle=variantTitle;
if (price) el.dataset.price=price;
if (comparePrice) el.dataset.comparePrice=comparePrice;
if (el._productData) {
if (variantId) el._productData.variantId='gid://shopify/ProductVariant/' + String(variantId).replace('gid://shopify/ProductVariant/', '');
if (variantTitle) el._productData.variantTitle=variantTitle;
if (price) el._productData.price=price;
if (comparePrice) el._productData.compareAtPrice=comparePrice;
}
});
}
document.addEventListener('change', (e) => {
const sel=e.target;
if (sel.tagName==='SELECT'&&sel.name==='id') {
const opt=sel.options[sel.selectedIndex];
syncVariant(
sel.value,
opt?.dataset.variantTitle||opt?.text||'',
opt?.dataset.price||'',
opt?.dataset.compareAtPrice||''
);
}
});
document.addEventListener('variant:change', (e) => {
const v=e.detail?.variant;
if (!v) return;
const fmt=(cents) =>
cents != null
? new Intl.NumberFormat(navigator.language||'en-CA', {
style: 'currency',
currency: window.Shopify?.currency?.active||'CAD',
}).format(cents / 100)
: '';
syncVariant(v.id, v.title, fmt(v.price), fmt(v.compare_at_price));
});
document.addEventListener('shopify:section:load', () => {
if (window.WishlistAPI?.state?.loaded) {
window.WishlistAPI['_emit']?.();
}
});
})();